import { useFeatureFlagEnabled } from '@/lib/config/featureflag'

import { useIsSupportUser } from './support-user'

export const useDiscoveryModuleAccess = (): { hasAccess: boolean; isLoading: boolean } => {
  const { isEnabled, isLoading } = useFeatureFlagEnabled('discovery-module')
  const isSupportUser = useIsSupportUser()
  return { hasAccess: isEnabled || isSupportUser, isLoading }
}
